import { render, staticRenderFns } from "./AccountItem.vue?vue&type=template&id=31823096&scoped=true&"
import script from "./AccountItem.vue?vue&type=script&lang=js&"
export * from "./AccountItem.vue?vue&type=script&lang=js&"
import style0 from "./AccountItem.vue?vue&type=style&index=0&id=31823096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31823096",
  null
  
)

export default component.exports